var render = function render(){var _vm=this,_c=_vm._self._c;return _c('organizations-section',{key:_vm.updateKey,attrs:{"organizations":_vm.organizations},on:{"setPage":_vm.getOrganizations}})
}
var staticRenderFns = []

export { render, staticRenderFns }